import React from "react";
import PropTypes from "prop-types";

import { AppContext } from "components";
import "react-toastify/dist/ReactToastify.css";

import {
    ItemFamilySelect, WashingSelect,
    SizeSelect, BrandSelect, AttributeSelectButtons,
    SupplierSelect, ImagesUpload, DetailsSelectButtons, TagsSelectButtons
} from "components/ProductComponents";
import ProductCreateContainer from "./ProductCreateContainer";
import CategoriesSelectButtons from "components/ProductComponents/CategoriesSelectButtons";
import ColorSelectButtons from "components/ProductComponents/ColorSelectButtons";
import CutSelectButtons from "components/ProductComponents/CutSelectButtons";
import { CustomerSearchInput } from "shared/components/customers/misc/customer-search-input";

import { Checkbox } from 'shared/components/bulma/checkbox';
import TypeofgarmentSelect from "components/ProductComponents/TypeofgarmentSelect";
import MintConditionSelect from "components/ProductComponents/MintConditionSelect";
import CurrencySelect from "components/ProductComponents/CurrencySelect";
import WashingDetergentButton from "components/ProductComponents/WashingDetergentButton";
import GenderSelect from "components/ProductComponents/GenderSelect";
import MaterialComponent from "components/ProductComponents/MaterialComponent";
import PlatformSoldSelect from "components/ProductComponents/PlatformSoldSelect";
// import { DatePickerYear } from "shared/components/bulma/date-picker/DatePickerYear";
import Grid from '@material-ui/core/Grid';


class TabletProductCreateContainer extends ProductCreateContainer {

    constructor(props) {
        super(props);
        this.imagesUploadRef = React.createRef();
        this.imagesUploadRef1 = React.createRef();
        this.imagesUploadRef2 = React.createRef();
        this.imagesUploadRef3 = React.createRef();
    }

    render() {

        return (
            <React.Fragment>
                <div className="columns is-gapless">

                    <div className="column">
                        <div className="container mt-4 pt-4">
                            <form noValidate>

                                <ItemFamilySelect className="is-large" name="itemFamily" value={this.state.itemFamily} label="Item Family" id="item-family" onChange={this.onChange} />
                                <SizeSelect className="is-large" name="size" value={this.state.size} id="size-select" label="Size" onChange={this.onChange} />
                                <CategoriesSelectButtons className="is-large" name="category" value={this.state.category} label="Category" onChange={this.onChange} />
                                <CutSelectButtons category={this.state.category} className="is-large" name="cuts" id="cut-select" value={this.state.cuts} label="Cuts" onChange={this.onChange} />
                                <ColorSelectButtons className="is-large" name="color" value={this.state.color} label="Colors" id="color-select" onChange={this.onChange} />
                                <AttributeSelectButtons className="is-large" name="attributes" value={this.state.attributes} label="Attributes" id="attribute-select" onChange={this.onChange} />
                                <TagsSelectButtons className="is-large" name="tags" id="tag-select" value={this.state.tags} placeholder="Tags" label="Tags" onChange={this.onChange} />
                                <DetailsSelectButtons className="is-large" name="details" id="details-select" value={this.state.details} placeholder="Details" label="Details" onChange={this.onChange} />
                                <WashingDetergentButton className="is-large" name="washingdetergent" value={this.state.washingdetergent} label="Wash With" id="washingdetergent-select" onChange={this.onChange} />
                                <WashingSelect name="washing" value={this.state.washing} id="washing-select" label="Washing" onChange={this.onChange} />

                                <div className="field">
                                    <label className="label">Id</label>
                                    <div className="control">
                                        <input
                                            className="input is-large"
                                            name="uid"
                                            type="text"
                                            value={this.state.uid}
                                            disabled
                                            onChange={this.onChange}
                                            placeholder="Id" />
                                    </div>
                                </div>
                                <div className="field">
                                    <label className="label">Name</label>
                                    <div className="control">
                                        <input
                                            className="input is-large"
                                            name="name"
                                            type="text"
                                            value={this.state.name}
                                            onChange={this.onChange}
                                            placeholder="Name" />
                                    </div>
                                </div>

                                <div className="field">
                                    <label className="label">Barcode</label>
                                    <div className="control">
                                        <input
                                            className="input is-large"
                                            name="barcode"
                                            type="text"
                                            value={this.state.barcode}
                                            onChange={this.onChange}
                                            placeholder="XXXXXXXX" />
                                    </div>
                                </div>

                                <BrandSelect className="is-large" name="brand" value={this.state.brand} id="brand-select" label="Brand" onChange={this.onChange} />
                                <SupplierSelect className="is-large" name="supplier" value={this.state.supplier} id="supplier-select" label="Supplier" onChange={this.onChange} /> 
                                <CustomerSearchInput
                                    className="is-large"
                                    name="userSelected" placeholder="Type customer's name"
                                    value={this.state.userSelected}
                                    id="customer-search" label="Excluded Customer" onChange={this.onChange} />
                                <div className="field">
                                    <label className="label">Description</label>
                                    <div className="control">
                                        <input
                                            className="input is-large"
                                            name="description"
                                            type="text"
                                            value={this.state.description}
                                            onChange={this.onChange}
                                            placeholder="Description" />
                                    </div>
                                </div>
                                <TypeofgarmentSelect className="is-large" name="typeofgarment" value={this.state.typeofgarment} id="typeofgarment-select" label="Type Of Garment" onChange={this.onChange} /> 
                                <MintConditionSelect className="is-large" name="mintcondition" value={this.state.mintcondition} id="mintcondition-select" label="Condition" onChange={this.onChange} />
                                {
                                    window.localStorage.getItem('role') === 'admin' || window.localStorage.getItem('role') === 'merchandiser'
                                        || window.localStorage.getItem('role') === 'buyer' ? 
                                        <>
                            <Grid style={{ display: 'flex' }}>
                                <Grid item lg={10} md={10} sm={9} xs={7} className="field">
                                    <label className="label">Buying Price</label>
                                    <div className="control">
                                        <input
                                            className="input is-large"
                                            name="buyingprice"
                                            type="number"
                                            value={this.state.buyingprice}
                                            onChange={this.onChange}
                                            placeholder="Buying Price" />
                                    </div>
                                </Grid>   
                                <Grid item lg={2} md={2} sm={3} xs={5}>
                                    <CurrencySelect className="is-large" name="currency" value={this.state.currency} id="currency-select" label="Currency" onChange={this.onChange} />
                                </Grid>
                             </Grid>
                                <Grid  style={{ display: 'flex' }}>

                                    <Grid item lg={10} md={10} sm={9} xs={7}  className="field" >
                                         <label className="label">Target Sale Price</label>
                                         <div className="control">
                                        <input
                                            className="input is-large"
                                            name="targetsalesprice"
                                            type="number"
                                            value={this.state.targetsalesprice}
                                            onChange={this.onChange}
                                            placeholder="Target Sale Price" />
                                         </div>
                                                </Grid>
                                <Grid item lg={2} md={2} sm={3} xs={5}>
                                    <CurrencySelect className="is-large" name="currency" value={this.state.currency} id="currency-select" label="Currency" onChange={this.onChange} />
                                </Grid>
                                </Grid>



                                <Grid style={{ display: 'flex' }}>
            
                                    <Grid item lg={10} md={10} sm={9} xs={7}  className="field">
                                    <label className="label">Final Sale Price</label>
                                    <div className="control">
                                        <input
                                            className="input is-large"
                                            name="finalsalesprice"
                                            type="number"
                                            value={this.state.finalsalesprice}
                                            onChange={this.onChange}
                                            placeholder="Final Sale Price" />
                                    </div>
                                    </Grid>
                                     <Grid item lg={2} md={2} sm={3} xs={5}>
                                    <CurrencySelect className="is-large" name="currency" value={this.state.currency} id="currency-select" label="Currency" onChange={this.onChange} />
                                    </Grid>
                                </Grid>
                             
                                <Grid style={{ display: 'flex'}}>

                                    <Grid item lg={10} md={10} sm={9} xs={7} className="field" >
                                    <label className="label">Profit</label>
                                    <div className="control">
                                        <input
                                            className="input is-large"
                                            type="number"
                                            value={this.state.finalsalesprice - this.state.buyingprice} />
                                                
                                    </div>
                                </Grid>
                                <Grid item lg={2} md={2} sm={3} xs={5}>
                                    <CurrencySelect className="is-large" name="currency" value={this.state.currency} id="currency-select" label="Currency" onChange={this.onChange} />
                                </Grid>
                                    </Grid>
                                             
                                            </>
                                            :''
                              }
                                
                                   

                                <GenderSelect className="is-large" name="gender" value={this.state.gender} id="currency-select" label="Gender" onChange={this.onChange} />
                                
                                {
                                    window.localStorage.getItem('role') === 'admin'&&<PlatformSoldSelect className="is-large" name="platformsold" value={this.state.platformsold} id="platformsold-select" label="Platform Sold" onChange={this.onChange} />

                                }
                                <MaterialComponent className="is-large" setState={this.setState} state={this.state}  />
                                {/* <DatePickerYear
                                    className="is-large"
                                    name="yearofproduction"
                                    value={this.state.yearofproduction}
                                    id="yearofproduction-select"
                                    label={'Year Of Production'}
                                    onChange={this.onChange}
                                /> */}
                                <div className="field">
                                    <label className="label">Year Of Production</label>
                                    <div className="control">
                                        <input
                                            className="input is-large"
                                            name="yearofproduction"
                                            type="text"
                                            value={this.state.yearofproduction}
                                            onChange={this.onChange}
                                            placeholder="Year Of Production" />
                                    </div>
                                </div>
                                <div className="columns">

                                <div className="column is-6">

                                    <div style={{display:'flex',alignItems:'center'}}>
                                        <Checkbox  name="sold" onChange={this.onChangeCheckbox} checked={this.state.sold}>
                                        </Checkbox>
                                        <label className="label">Sold</label>
                                    </div>
                                </div>
                                </div>
                                <div className="columns">
                                    <div className="column is-6">

                                        {/* <ImagesUpload size="is-small" ref={this.imagesUploadRef} onChange={this.onChangeImages} /> */}
                                        <label className="label">Before Wash Images</label>
                                        <div style={{ display: 'flex' }}>
        
                                        <ImagesUpload size="is-small" create="create" angle="Front" ref={this.imagesUploadRef} onChange={this.onChangeImagesBF} />
                                        <ImagesUpload size="is-small" create="create" angle="Back" ref={this.imagesUploadRef1} onChange={this.onChangeImagesBB} />
                                        </div>
                                        <br />
                                        <label className="label">After Wash Images</label>
                                        <div style={{ display: 'flex' }}>
                                        <ImagesUpload size="is-small" create="create" angle="Front"  ref={this.imagesUploadRef2} onChange={this.onChangeImagesAF} />
                                        <ImagesUpload size="is-small" create="create" angle="Back" ref={this.imagesUploadRef3} onChange={this.onChangeImagesAB} />
                                        </div>
                                        
                                        <label className="label">App Preview</label>
                                        <div>
                                            <Checkbox name="appPreview" onChange={this.onChangeCheckbox} checked={this.state.appPreview}>
                                            </Checkbox>
                                        </div>
                                    </div>
                                </div>
                                <div className="field is-grouped">
                                    <div className="control">
                                        <button
                                            name="submit"
                                            type="button"
                                            className="button is-primary"
                                            onClick={this.createProduct}>Submit</button>
                                    </div>
                                    <div className="control">
                                        <button type="button"
                                            name="reset"
                                            className="button is-primary is-light"
                                            onClick={this.resetState}>Reset</button>
                                    </div>

                                </div>
                            </form>

                        </div>
                    </div>
                </div>

                {/* CONFIRMATION MODAL  */}
                <div className={`modal ${this.state.isModalVisible ? 'is-active' : ''}`}>
                    <div className="modal-background"></div>
                    <div className="modal-card">
                        <header className="modal-card-head">
                            <p className="modal-card-title">Confirmation</p>
                            <button className="delete" aria-label="close"></button>
                        </header>
                        <section className="modal-card-body">
                            <p>Are you sure to import this product?</p>
                        </section>
                        <footer className="modal-card-foot">
                            <button type="button" className="button is-primary" onClick={this.handleModalAgree}>Yes</button>
                            <button type="button" className="button" onClick={this.handleModalDisagree}>No</button>
                        </footer>
                    </div>
                </div>
            </React.Fragment>
        );
    }
}

TabletProductCreateContainer.contextType = AppContext;

TabletProductCreateContainer.propTypes = {
    history: PropTypes.object
};

export default TabletProductCreateContainer;
